/* =========================================================
   HG VARIANT SYNC (GLOBAL FIX v4 + UI UPDATE SAFE)
   - varianta corecta la submit (ATC + Buy it now)
   - update vizual: pret + compare + buton (foloseste data-text-*)
   - update vizual optiuni curente (size etc)
========================================================= */
(function () {
  "use strict";

  function norm(s) {
    return String(s || "")
      .replace(/\u00A0/g, " ")
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase();
  }

  function moneyRON(cents) {
    try {
      const v = Number(cents || 0) / 100;
      return v.toLocaleString("ro-RO", { style: "currency", currency: "RON" });
    } catch (e) {
      return (Number(cents || 0) / 100).toFixed(2) + " lei";
    }
  }

  function cleanupIdInputs(form) {
    const ids = form.querySelectorAll('[name="id"]');
    if (!ids.length) return null;

    // Preferam SELECT (cel corect)
    let keep = null;
    ids.forEach((el) => {
      if (!keep && el.tagName === "SELECT") keep = el;
    });
    if (!keep) keep = ids[0];

    ids.forEach((el) => {
      if (el !== keep) el.remove();
    });

    keep.disabled = false;
    return keep;
  }

  function getSelectedOptionsFromForm(form) {
    // Template HG (recomandat)
    const radios = form.querySelectorAll("input[data-opt-radio]:checked");
    if (radios && radios.length) {
      const selected = [];
      radios.forEach((r) => {
        const idx = parseInt(r.getAttribute("data-opt-index") || "0", 10);
        selected[idx] = r.value;
      });
      return selected;
    }

    // fallback generic
    const any = form.querySelectorAll('input[type="radio"]:checked');
    if (any && any.length) return Array.from(any).map((r) => r.value);

    return [];
  }

  function findMatchingVariantOption(select, selectedOptions) {
    const s0 = norm(selectedOptions[0]);
    const s1 = norm(selectedOptions[1]);
    const s2 = norm(selectedOptions[2]);

    const options = Array.from(select.options || []);
    if (!options.length) return null;

    for (const opt of options) {
      const o1 = norm(opt.getAttribute("data-option1"));
      const o2 = norm(opt.getAttribute("data-option2"));
      const o3 = norm(opt.getAttribute("data-option3"));

      const ok1 = s0 ? s0 === o1 : true;
      const ok2 = s1 ? s1 === o2 : true;
      const ok3 = s2 ? s2 === o3 : true;

      if (ok1 && ok2 && ok3) return opt;
    }

    // fallback doar pe prima optiune
    if (s0) {
      for (const opt of options) {
        const o1 = norm(opt.getAttribute("data-option1"));
        if (o1 && o1 === s0) return opt;
      }
    }

    return null;
  }

  function getVariantsJsonNearForm(form) {
    const root =
      form.closest(".hg-product") ||
      form.closest(".product-details-page") ||
      document;

    const jsonEl = root.querySelector('[data-hg-variants-json]');
    if (!jsonEl) return null;

    try {
      const v = JSON.parse(jsonEl.textContent || "[]");
      return Array.isArray(v) ? v : null;
    } catch (e) {
      return null;
    }
  }

  function findVariantById(variants, id) {
    if (!variants) return null;
    const sid = String(id || "");
    return variants.find((v) => String(v.id) === sid) || null;
  }

  function updateOptionCurrentLabels(root) {
    try {
      // Noua UI HG
      const optBlocks = root.querySelectorAll(".hg-opt[data-opt-index]");
      optBlocks.forEach((b) => {
        const checked = b.querySelector('input[data-opt-radio]:checked');
        const cur = b.querySelector("[data-opt-current]");
        if (cur && checked) cur.textContent = checked.value;
      });

      // Fallback vechi
      const oldBlocks = root.querySelectorAll(".variant-option-block");
      oldBlocks.forEach((b) => {
        const cur = b.querySelector(".current-option");
        const checked = b.querySelector('input[type="radio"]:checked');
        if (cur && checked) cur.textContent = checked.value;
      });
    } catch (e) {}
  }

  function updateUI(form, variant) {
    const root =
      form.closest(".hg-product") ||
      form.closest(".product-details-page") ||
      document;

    const priceEl = root.querySelector("#ProductPrice");
    const compareEl = root.querySelector("#ComparePrice");
    const atcBtn = form.querySelector("[data-atc]");

    if (variant && priceEl) priceEl.textContent = moneyRON(variant.price);

    if (compareEl) {
      if (variant && variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = moneyRON(variant.compare_at_price);
        compareEl.style.display = "";
      } else {
        compareEl.style.display = "none";
      }
    }

    // BUTON: folosim strict data-atributele (din Liquid, deci traduse corect)
    if (atcBtn) {
      const span = atcBtn.querySelector("span");
      const textAdd = atcBtn.getAttribute("data-text-add") || "Adaugă în coș";
      const textSold = atcBtn.getAttribute("data-text-soldout") || "Stoc epuizat";

      if (!variant || variant.available === false) {
        atcBtn.disabled = true;
        if (span) span.textContent = textSold;
      } else {
        atcBtn.disabled = false;
        if (span) span.textContent = textAdd;
      }
    }

    updateOptionCurrentLabels(root);
  }

  function syncVariantForForm(form) {
    if (!form) return;

    cleanupIdInputs(form);

    const select = form.querySelector('select[name="id"]');
    const selectedOptions = getSelectedOptionsFromForm(form);

    if (select) {
      const match = findMatchingVariantOption(select, selectedOptions);
      if (match) select.value = match.value;

      const variants = getVariantsJsonNearForm(form);
      const variant = findVariantById(variants, select.value);

      updateUI(form, variant);

      // URL variant
      try {
        const url = new URL(window.location.href);
        url.searchParams.set("variant", String(select.value));
        window.history.replaceState({}, "", url.toString());
      } catch (e) {}

      select.disabled = false;
    }
  }

  function bindForm(form) {
    if (!form || form.__hgBoundV4) return;
    form.__hgBoundV4 = true;

    // initial
    syncVariantForForm(form);

    // change / click
    form.addEventListener(
      "change",
      function (e) {
        const t = e.target;
        if (!t) return;
        if (t.matches("input[data-opt-radio]") || t.matches('input[type="radio"]') || t.matches("select")) {
          syncVariantForForm(form);
        }
      },
      true
    );

    form.addEventListener(
      "click",
      function (e) {
        const lbl = e.target && e.target.closest ? e.target.closest("label") : null;
        if (!lbl) return;
        setTimeout(function () {
          syncVariantForForm(form);
        }, 0);
      },
      true
    );

    // submit safety
    form.addEventListener(
      "submit",
      function () {
        syncVariantForForm(form);
      },
      true
    );
  }

  function boot() {
    document
      .querySelectorAll('form[action*="/cart/add"], form[action*="cart/add"], form[data-type="add-to-cart-form"]')
      .forEach(bindForm);
  }

  document.addEventListener("DOMContentLoaded", boot);
  document.addEventListener("shopify:section:load", boot);
})();
